import React from 'react';
import HeaderThree from '../../common/header/HeaderThree';
import BannerTwo from '../../components/section-components/BannerTwo';
import WelcomeThree from '../../components/section-components/WelcomeThree';
import AwardOne from '../../components/section-components/AwardOne';
import Experiences from '../../components/section-components/Experiences';
import PracticeAreasThree from '../../components/section-components/PracticeAreasThree';
import OurAttorneysThree from '../../components/section-components/OurAttorneysThree';
import Counter from '../../components/section-components/Counter';
import BlogThree from '../../components/section-components/BlogThree';
import TestimonialThree from '../../components/section-components/TestimonialThree';
import FooterThree from '../../common/footer/FooterThree';

const HomeThree = () => {
    return (
        <>
        <HeaderThree />

        <BannerTwo />
        
        <WelcomeThree />
        
        <AwardOne /> 
        
        <Experiences />
        
        <PracticeAreasThree />
        
        <OurAttorneysThree />
        
        <Counter />
        
        <BlogThree />
        
        <TestimonialThree />

        <FooterThree />
        </>
        )
}
    
export default HomeThree;